import {Checkbox as ArkCheckbox} from '@ark-ui/react/checkbox'
import './index.less'

/**
 * @typedef {Object} CheckboxRootProps
 * @property {import('react').ReactNode} children Checkbox parts rendered inside the root.
 * @property {boolean | 'indeterminate'} [checked] Controlled checked state.
 * @property {(value: boolean) => void} [onChange] Called with the next checked state.
 * @property {boolean} [disabled] Prevents interaction with the checkbox.
 * @property {string} [className] Additional root classname.
 * @property {import('react').MouseEventHandler<HTMLLabelElement>} [onClick]
 */

/** @param {CheckboxRootProps} props */
export const CheckboxRoot = ({children, checked, onChange, disabled, className, onClick}) => {
	const handleCheckedChange = details => onChange?.(details.checked === true)

	const handleClick = event => {
		// If the click event comes from its associated input (e.g. ArkCheckbox.HiddenInput), ignore it.
		// This is to prevent `onClick` from being called twice
		if (event.target === event.currentTarget.control) {
			event.stopPropagation()
			return
		}

		onClick?.(event)
	}

	return (
		<ArkCheckbox.Root
			checked={checked}
			onCheckedChange={handleCheckedChange}
			disabled={disabled}
			className={className}
			onClick={handleClick}
		>
			{children}
		</ArkCheckbox.Root>
	)
}
